import { useState } from "react";
import { Share2, Copy, Check } from "lucide-react";
import { toast } from "sonner";

export default function ShareBar({ url, text = "Check this out on Suvikka 💗", label = "Share", compact = false }) {
  const [copied, setCopied] = useState(false);
  const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const enc = encodeURIComponent(`${text} ${shareUrl}`);
  const copy = async () => {
    try { await navigator.clipboard.writeText(shareUrl); setCopied(true); toast.success("Link copied 💗"); setTimeout(() => setCopied(false), 1800); }
    catch { toast.error("Could not copy"); }
  };
  const native = async () => {
    if (navigator.share) { try { await navigator.share({ title: "Suvikka", text, url: shareUrl }); } catch {} }
    else copy();
  };
  return (
    <div className={`flex items-center gap-2 ${compact ? "" : "flex-wrap"}`} data-testid="share-bar">
      {!compact && <span className="text-xs font-semibold uppercase tracking-wider text-stone-400">{label}</span>}
      <a href={`https://wa.me/?text=${enc}`} target="_blank" rel="noreferrer" data-testid="share-whatsapp"
        className="inline-flex items-center gap-1.5 text-xs font-semibold bg-[#25D366] text-white px-3 py-2 rounded-full hover:opacity-90">WhatsApp</a>
      <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`} target="_blank" rel="noreferrer" data-testid="share-facebook"
        className="inline-flex items-center gap-1.5 text-xs font-semibold bg-[#1877F2] text-white px-3 py-2 rounded-full hover:opacity-90">Facebook</a>
      <button onClick={copy} data-testid="share-copy" className="inline-flex items-center gap-1.5 text-xs font-semibold border border-stone-300 text-stone-700 px-3 py-2 rounded-full hover:border-[#6A1B29]">
        {copied ? <Check className="w-3.5 h-3.5 text-green-600" /> : <Copy className="w-3.5 h-3.5" />} {copied ? "Copied" : "Copy link"}
      </button>
      <button onClick={native} data-testid="share-native" className="inline-flex items-center gap-1.5 text-xs font-semibold bg-stone-900 text-white px-3 py-2 rounded-full hover:bg-stone-800">
        <Share2 className="w-3.5 h-3.5" /> Share
      </button>
    </div>
  );
}
